import { Pipe, PipeTransform } from '@angular/core';
import { number_format } from '../utils/utils';

@Pipe({
  name: 'money',
  standalone: false,
})
export class MoneyPipe implements PipeTransform {

  transform(value: number | string, ...args: unknown[]): unknown {
    return number_format(Number(value));
  }

}
